import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AssassinsHideout3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ASSASINS_HIDEOUT3;
}

export default AssassinsHideout3PoiTileEntity;
